import { Controller } from '@hotwired/stimulus'
import { createApp } from 'vue'
import LoginsChart from '@/components/admin/analytics/logins_chart.vue'

export default class extends Controller {
  static values = { payload: Object }

  connect () {
    this.vue = createApp(LoginsChart, { series: this.payloadValue?.series || [] })
    this.vue.mount(this.element)
  }

  disconnect () {
    this.vue?.unmount()
  }
}
